// Make a nicemodal from ebay with mui dialog. That can take message variable along with the type of messsage, erorr or info/success.

import Lottie from 'react-lottie-player';
import React, { useCallback } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { Box, Stack, Dialog, Typography } from '@mui/material';

import { useLoadingStore } from 'src/store/LoadingStore';
import LoadingAnimation from 'src/assets/lottie/LoadingLottie.json';

export default NiceModal.create(() => {
  const modal = useModal();
  const handleClose = useCallback(() => {
    modal.hide();
    modal.remove();
  }, [modal]);

  const { isLoadingModalOpen } = useLoadingStore.getState();

  if (!isLoadingModalOpen) {
    modal.hide();
    modal.remove();
    return null;
  }
  return (
    <Dialog
      open={modal.visible}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      fullWidth
      title="Loading"
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
      // slotProps={{
      //   backdrop: {
      //     style: {
      //       backgroundColor: 'transparent',
      //       boxShadow: 'none',
      //     },
      //   },
      // }}
      sx={{
        '& .MuiDialog-paper': {
          m: 0,
          p: 2,
          borderRadius: 4,
        },
      }}
    >
      <Box sx={{ width: '100%' }}>
        <Stack sx={{ my: 2 }}>
          <Typography textAlign="center" fontWeight="bold" variant="h2" color="primary">
            Loading...
          </Typography>
          <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
            <Lottie
              loop
              animationData={LoadingAnimation}
              play
              style={{ width: 450, height: 450 }}
            />
          </Stack>
        </Stack>
      </Box>
    </Dialog>
  );
});
